import React from 'react';

import { Typography } from '@lyearn/ui';

const FormHeader = () => {
  return (
    <>
      <Typography as="h1" className="mb-6 text-center" variant="display-xxl">
        Forgot Password?
      </Typography>
      <Typography
        as="div"
        className="mb-26 flex items-center justify-center"
        variant="body-long-02">
        Password reset link will be sent to this email
      </Typography>
    </>
  );
};

export default FormHeader;
